module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_j_albino.317ae9f8.png";